<ng-template appPrefixContainer />

<ng-template #noPrefixComponent>
  <span>Cannot find template in table -> {{ field ? field.template : "??" }}</span>
</ng-template>
